import { connect } from 'react-redux';
import Component from './Component';
import { showLogin, hideAll, submitLogin, showResetPassword, resetPasswordSendEmail } from './Actions';

const mapStateToProps = (state) => (
  {
    auth: state.auth,
  }
);

const mapDispatchToProps = (dispatch) => (
  {
    showLogin: () => {
      dispatch(showLogin())
    },
    showResetPassword: () => {
      dispatch(showResetPassword())
    },
    hideAll: () => {
      dispatch(hideAll())
    },
    submitLogin: (data) => {
      dispatch(submitLogin(data))
    },
    resetPasswordSendEmail: (data) => {
      dispatch(resetPasswordSendEmail(data))
    }
  }
);

export default connect(mapStateToProps, mapDispatchToProps)(Component);


// WEBPACK FOOTER //
// ./src/app/containers/Auth/index.js